/* Breezy theme — storefront interactions. No dependencies. */
(() => {
  const theme = window.theme || {};
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  /* Toast ------------------------------------------------------------------ */
  let toastTimer;
  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* Header ------------------------------------------------------------------ */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const mobileNav = $('[data-mobile-nav]');
  const navToggle = $('[data-nav-toggle]');
  function setNav(open) {
    if (!mobileNav) return;
    mobileNav.hidden = !open;
    navToggle && navToggle.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  }
  navToggle && navToggle.addEventListener('click', () => setNav(true));
  $$('[data-nav-close]').forEach((el) => el.addEventListener('click', () => setNav(false)));

  const search = $('[data-search]');
  if (search) {
    search.addEventListener('toggle', () => {
      if (search.open) setTimeout(() => $('input[type="search"]', search).focus(), 30);
    });
    document.addEventListener('click', (event) => {
      if (search.open && !search.contains(event.target)) search.open = false;
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setNav(false);
    closeCart();
    if (search) search.open = false;
  });

  /* Announcement rotator ---------------------------------------------------- */
  $$('[data-rotator]').forEach((track) => {
    const items = $$('.announcement__item', track);
    if (items.length < 2) return;
    let index = 0;
    setInterval(() => {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, Number(track.dataset.interval) || 5000);
  });

  /* Cart -------------------------------------------------------------------- */
  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;

  function openCart() {
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    const panel = $('.drawer__panel', drawer);
    panel && panel.focus();
    return true;
  }

  function closeCart() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener && drawer && theme.template !== 'cart') {
      event.preventDefault();
      openCart();
      return;
    }
    if (event.target.closest('[data-cart-close]')) closeCart();
  });

  function cartSectionIds() {
    return $$('[data-cart-contents]').map((el) => el.dataset.sectionId);
  }

  function renderCartSections(sections) {
    if (!sections) return;
    $$('[data-cart-contents]').forEach((container) => {
      const html = sections[container.dataset.sectionId];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-contents]');
      if (fresh) container.innerHTML = fresh.innerHTML;
    });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  }

  async function refreshCount() {
    const cart = await fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    updateCount(cart.item_count);
    return cart;
  }

  // Add to cart via AJAX for every product form on the page.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form || theme.cartType !== 'drawer' || !drawer) return;
    event.preventDefault();

    const button = event.submitter && event.submitter.name === 'add' ? event.submitter : $('[type="submit"][name="add"], [data-add-button]', form) || $('[type="submit"]', form);
    const label = button ? button.innerHTML : '';
    if (button) {
      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
      button.textContent = theme.strings.adding;
    }

    const body = new FormData(form);
    body.append('sections', cartSectionIds().join(','));
    body.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message);
      renderCartSections(data.sections);
      await refreshCount();
      openCart();
    } catch (error) {
      toast(error.message || 'Something went wrong');
    } finally {
      if (button) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
        button.innerHTML = label;
      }
    }
  });

  // Quantity changes and removal inside the cart page and drawer.
  document.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-line-change]');
    if (!control) return;
    event.preventDefault();
    const item = control.closest('.cart-item');
    item && item.classList.add('is-loading');

    try {
      const response = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(control.dataset.lineChange),
          quantity: Number(control.dataset.quantity),
          sections: cartSectionIds(),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message);
      renderCartSections(data.sections);
      updateCount(data.item_count);
    } catch (error) {
      item && item.classList.remove('is-loading');
      toast(error.message || 'Something went wrong');
    }
  });

  document.addEventListener('change', (event) => {
    const note = event.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(`${theme.routes.cart}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value }),
    });
  });

  /* Quantity selector ------------------------------------------------------- */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-qty-plus], [data-qty-minus]');
    if (!btn) return;
    const input = $('input', btn.closest('[data-quantity]'));
    const step = btn.hasAttribute('data-qty-plus') ? 1 : -1;
    input.value = Math.max(1, (Number(input.value) || 1) + step);
  });

  /* Product: gallery, variants, sticky bar --------------------------------- */
  function initGallery(gallery) {
    const slides = $('[data-gallery-slides]', gallery);
    const thumbs = $$('[data-thumb]', gallery);
    if (!slides) return {};

    function show(mediaId, smooth = true) {
      const slide = $(`[data-media-id="${mediaId}"]`, slides);
      if (!slide) return;
      slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(thumb.dataset.thumb)));

    if (thumbs.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const id = entry.target.dataset.mediaId;
            thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === id));
          });
        },
        { root: slides, threshold: 0.6 }
      );
      $$('[data-media-id]', slides).forEach((slide) => observer.observe(slide));
    }

    const featured = $('[data-featured]', slides);
    if (featured && featured !== slides.firstElementChild) show(featured.dataset.mediaId, false);

    return { show };
  }

  function initProduct(root) {
    const info = $('[data-product-info]', root);
    if (!info) return;
    const gallery = $('[data-gallery]', root);
    const galleryApi = gallery ? initGallery(gallery) : {};
    const picker = $('[data-variant-picker]', info);
    const form = $('[data-product-form]', info);
    const idInput = form && $('[data-variant-id]', form);
    const addButton = form && $('[data-add-button]', form);
    const priceContainer = $('[data-price-container]', info);
    const stock = $('[data-stock]', info);
    const sticky = root.closest('.shopify-section') && document.querySelector('[data-sticky-atc]');
    const isMain = info.dataset.updateUrl === 'true';

    if (picker) {
      const variants = JSON.parse($('[data-variants-json]', picker).textContent);
      const inputs = $$('input[type="radio"]', picker);

      const selectedOptions = () => {
        const groups = {};
        inputs.forEach((input) => {
          if (input.checked) groups[input.dataset.optionIndex] = input.value;
        });
        return Object.keys(groups).sort().map((key) => groups[key]);
      };

      const markAvailability = (selected) => {
        inputs.forEach((input) => {
          const index = Number(input.dataset.optionIndex);
          const candidate = selected.slice();
          candidate[index] = input.value;
          // Available if some in-stock variant matches every option up to and including this one.
          const exists = variants.some((v) => v.available && v.options.every((opt, i) => i > index || opt === candidate[i]));
          input.classList.toggle('is-unavailable', !exists);
        });
      };

      const update = () => {
        const selected = selectedOptions();
        selected.forEach((value, i) => {
          const label = $(`[data-option-label="${i}"]`, picker);
          if (label) label.textContent = value;
        });
        markAvailability(selected);

        const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        if (!variant) {
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = theme.strings.unavailable;
          }
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        }

        const priceTemplate = $(`[data-variant-price="${variant.id}"]`, info);
        if (priceContainer && priceTemplate) priceContainer.innerHTML = priceTemplate.innerHTML;

        const stockTemplate = $(`[data-variant-stock="${variant.id}"]`, info);
        if (stock && stockTemplate) stock.innerHTML = stockTemplate.innerHTML;

        if (variant.featured_media && galleryApi.show) galleryApi.show(variant.featured_media.id);

        if (isMain) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
          if (sticky) {
            const stickyPrice = $('[data-sticky-price]', sticky);
            if (stickyPrice && priceTemplate) {
              stickyPrice.innerHTML = priceTemplate.innerHTML;
              const badge = $('.badge', stickyPrice);
              badge && badge.remove();
            }
            const stickyButton = $('[data-sticky-add]', sticky);
            if (stickyButton) {
              stickyButton.disabled = !variant.available;
              stickyButton.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
            }
          }
        }
      };

      picker.addEventListener('change', update);
      markAvailability(selectedOptions());
    }

    // Sticky add-to-cart bar on the main product page.
    if (isMain && sticky && addButton) {
      const stickyButton = $('[data-sticky-add]', sticky);
      stickyButton &&
        stickyButton.addEventListener('click', () => {
          if (form.requestSubmit) form.requestSubmit(addButton);
          else addButton.click();
        });
      const observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyButton && (stickyButton.tabIndex = show ? 0 : -1);
        document.body.classList.toggle('has-sticky-atc', show);
      });
      observer.observe(addButton);
    }

    // Share button.
    const share = $('[data-share]', info);
    share &&
      share.addEventListener('click', async () => {
        const data = { title: share.dataset.title, url: window.location.href };
        if (navigator.share) {
          try { await navigator.share(data); } catch (e) { /* dismissed */ }
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(data.url);
          toast('Link copied');
        }
      });
  }

  $$('[data-product-section]').forEach(initProduct);

  /* Collection filters & sorting ------------------------------------------- */
  $$('[data-filter-form]').forEach((form) => {
    form.addEventListener('submit', () => {
      $$('input, select', form).forEach((field) => {
        if (!field.value) field.disabled = true;
      });
    });
    $$('[data-auto-submit]', form).forEach((select) =>
      select.addEventListener('change', () => (form.requestSubmit ? form.requestSubmit() : form.submit()))
    );
    document.addEventListener('click', (event) => {
      $$('details.filter[open]', form).forEach((d) => {
        if (!d.contains(event.target)) d.open = false;
      });
    });
  });

  /* Product recommendations ------------------------------------------------ */
  $$('[data-recommendations]').forEach(async (section) => {
    try {
      const html = await fetch(section.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) section.innerHTML = fresh.innerHTML;
    } catch (e) {
      /* recommendations are optional */
    }
  });

  /* Theme editor support ---------------------------------------------------- */
  document.addEventListener('shopify:section:load', (event) => {
    $$('[data-product-section]', event.target).forEach(initProduct);
  });

  window.theme.openCart = openCart;
})();
